module.exports = __webpack_public_path__ + "img/alfie-w9.92ec0310.jpeg";